export default {
  authenticated: false,
}
